import { Stack, Skeleton, useTheme } from "@mui/material";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";

type ActivityFiltersSkeletonProps = {
  count?: number;
  height?: number;
};

const ActivityFiltersSkeleton = ({
  count = 2,
  height = 36,
}: ActivityFiltersSkeletonProps) => {
  const theme = useTheme();
  const { isMobile } = useScreenSize();

  if (isMobile) {
    return (
      <Stack direction="row" alignItems="center" gap={theme.nawy.spacing.xs}>
        <Skeleton
          variant="rectangular"
          width={40}
          height={height}
          sx={{ borderRadius: theme.nawy.radius.lg }}
        />
        <Skeleton
          variant="rounded"
          width={140} // Slightly wider to accommodate dynamic filter text
          height={height}
          sx={{ borderRadius: theme.nawy.radius.lg }}
        />
      </Stack>
    );
  }

  // More realistic widths for desktop filter buttons
  const widths = [100, 140, 120, 160];

  return (
    <Stack direction="row" alignItems="center" gap={theme.nawy.spacing.xs}>
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton
          key={i}
          variant="rounded"
          width={widths[i % widths.length]}
          height={height}
          sx={{ borderRadius: theme.nawy.radius.lg }}
        />
      ))}
    </Stack>
  );
};

export default ActivityFiltersSkeleton;
